export default __webpack_public_path__ + "static/721-00e9215acda91149d9b19c22a1a6a03c.gif";